import React from "react";

export const StatusBadge = ({ isActive, className = "" }) => {
  return (
    <span
      className={`px-3 py-1 rounded-full text-sm font-medium ${className} ${
        isActive 
          ? "bg-green-100 text-green-700" 
          : "bg-red-100 text-red-700"
      }`}
    >
      {isActive ? "فعال" : "غیرفعال"}
    </span>
  );
};

// export default ProfileComponents;

export const UserCode = ({label='کد مشتری', code}) => {
    return (
        <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-lg">
                {label} : {code || "نامشخص"}
      </span>
    );
};

export const Heading = ({title, placeHolder=""}) => {
    return (
        <h1 className="text-[18px] font-bold text-[#182F4E] mb-2">
            {title || placeHolder}
        </h1>

    );
};

export const Heading2 = ({title, placeHolder=""}) => {
    return (
        <h1 className="text-sm text-[#2B5388] mt-[18px]">
            {title || placeHolder}
        </h1>

    );
};

